"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _component = _interopRequireDefault(require("@loadable/component"));
var _PageContext = _interopRequireDefault(require("@micado-digital/react-ui/context/PageContext"));
var _useDescriptions = _interopRequireDefault(require("../../../ProductDetail/hooks/useDescriptions"));
var _Descriptions = _interopRequireDefault(require("./Descriptions.styles"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const Tab = (0, _component.default)(() => import("@material-ui/core/Tab"));
const Tabs = (0, _component.default)(() => import("@material-ui/core/Tabs"));
const Typography = (0, _component.default)(() => import("@material-ui/core/Typography"));
const Descriptions = () => {
  const [pageData] = (0, _react.useContext)(_PageContext.default);
  const {
    lang
  } = pageData || {};
  const [descriptions, setDescriptions] = (0, _react.useState)([]);
  const [value, setValue] = (0, _react.useState)(0);
  const _descriptions = (0, _useDescriptions.default)({
    lang
  });
  const css = (0, _Descriptions.default)();
  (0, _react.useEffect)(() => {
    setDescriptions(_descriptions === null || _descriptions === void 0 ? void 0 : _descriptions.filter(description => description.identifier !== "short"));
  }, [_descriptions]);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, !!descriptions.length && /*#__PURE__*/_react.default.createElement("div", {
    className: "mco-shop-product-detail-descriptions"
  }, /*#__PURE__*/_react.default.createElement(Tabs, {
    indicatorColor: "primary",
    scrollButtons: "auto",
    value: value,
    variant: "scrollable",
    onChange: handleChange
  }, descriptions === null || descriptions === void 0 ? void 0 : descriptions.map((description, index) => {
    const {
      title
    } = description || {};
    return /*#__PURE__*/_react.default.createElement(Tab, {
      key: index,
      label: title
    });
  })), descriptions === null || descriptions === void 0 ? void 0 : descriptions.map((description, index) => {
    const {
      description: text
    } = description || {};
    return /*#__PURE__*/_react.default.createElement("div", {
      hidden: value !== index,
      key: index,
      role: "tabpanel"
    }, value === index && /*#__PURE__*/_react.default.createElement("div", {
      className: (0, _clsx.default)(css.content, "mco-shop-product-detail-descriptions__content")
    }, /*#__PURE__*/_react.default.createElement(Typography, {
      className: "mco-shop-product-detail-descriptions__text",
      component: "div",
      dangerouslySetInnerHTML: {
        __html: text
      },
      variant: "body2"
    })));
  })));
};
var _default = exports.default = Descriptions;